import { render } from "./AyudaPersona.vue?vue&type=template&id=122ee188&scoped=true"
import script from "./AyudaPersona.vue?vue&type=script&lang=js"
export * from "./AyudaPersona.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=122ee188&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122ee188"]])

export default __exports__